// extracted by mini-css-extract-plugin
export var black = "_28-6";
export var brand = "_28-1";
export var ddefault = "_28-0";
export var error = "_28-3";
export var gray = "_28-2";
export var highContrast = "_28-8";
export var outline = "_28-7";
export var success = "_28-5";
export var warning = "_28-4";